import { Collection } from '@/resource/collection/collection.model';
import { Subject } from '@/resource/subject/subject.model';
import { User } from '@/resource/user/user.model';
import { Course } from '@/resource/course/course.model';
import { PaperGenerated } from '../paper-generated/paper-generated.model';

export enum PreCollectionSortBy {
  Latest = 'latest',
  Popular = 'popular',
  YearDSC = 'year-desc',
  YearASC = 'year-asc',
  LevelDSC = 'level-desc',
  LevelASC = 'level-asc',
}

export enum PreCollectionSortByFriendlyValue {
  'latest' = 'Latest',
  'popular' = 'Popular',
  'year-desc' = 'Year descending',
  'year-asc' = 'Year ascending',
  'level-desc' = 'Level descending',
  'level-asc' = 'Level ascending',
}

// NOTE: Generate array of enum values
export const preCollectionSortByList: PreCollectionSortBy[] = Object.keys(
  PreCollectionSortBy,
).map(key => PreCollectionSortBy[key]);

export enum PreCollectionType {
  Exam = 'exam',
  Practice = 'practice',
  Course = 'course',
  Note = 'note',
}

export enum PreCollectionContentType {
  Collection = 'collection',
  Pdf = 'pdf',
  Course = 'course',
  PaperGenerated = 'paper-generated',
}

export enum PreCollectionThumbnail {
  UASA = 'UASA',
  TOPIKAL = 'TOPIKAL',
  PERCUBAAN = 'PERCUBAAN',
  SPM = 'SPM',
  COURSE = 'COURSE',
  NOTE = 'NOTE',
  MODUL = 'MODUL',
}

export const preCollectionThumbnailList: PreCollectionThumbnail[] = Object.keys(
  PreCollectionThumbnail,
).map(key => PreCollectionThumbnail[key]);

// NOTE: Generate array of enum values
export const preCollectionTypeList: PreCollectionType[] = Object.keys(
  PreCollectionType,
).map(key => PreCollectionType[key]);

export interface PreCollectionCoupon {
  name: string;
  discount: number;
}

export interface PreCollection {
  id: number;
  uuid: string;
  name: string;
  description: string;
  details: string;
  type: PreCollectionType;
  form: number;
  year: number;
  downloadCount: number;
  pdfLink: string;
  pdfLinkPreview: string;
  isDraft: boolean;
  createdAt: Date;
  updatedAt: Date;
  collection: Collection;
  subject: Subject;
  user: User;
  totalQuestions: number;
  isPremium: boolean;
  course: Course;
  price: string;
  coupons: PreCollectionCoupon[] | null;
  thumbnail: PreCollectionThumbnail;
  paperGenerated: PaperGenerated;
}
